import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=1f3fe68f&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=1f3fe68f&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3fe68f')) {
      api.createRecord('1f3fe68f', component.options)
    } else {
      api.reload('1f3fe68f', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=1f3fe68f&", function () {
      api.rerender('1f3fe68f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tasks/_id.vue"
export default component.exports